import { Reducer } from 'redux';
import { STATE } from 'app/constants';
import { withOptionsReducer } from 'app/components/options-handler';
import { listReducer } from './list/reducers';
import { itemReducer } from './item/reducers';
import { CodetableMetadataState, CodetableAccessState } from './types-store';
import {
  ACTION, RequestMetadata, ReceiveMetadata, FailMetadata, RequestAccessCodetables, ReceiveAccessCodetables,
  FailAccessCodetables, RequestCodeItemAccessCodes, ReceiveCodeItemAccessCodes, FailCodeItemAccessCodes,
  ClearCodesAccess, ClearCodetablesAccess
} from './action-types';
import { mergeReducers } from 'app/infrastructure/redux/merge-reducers';

const INITIAL_CODETABLE_METADATA_STATE: CodetableMetadataState = {
  fetching: undefined,
  data: undefined
};

const INITIAL_CODETABLE_ACCESS_STATE: CodetableAccessState = {
  fetchingCodetables: undefined,
  fetchingCodes: undefined,
  data: undefined
};

const metadataReducers: { [indexer: string]: Reducer<CodetableMetadataState> } = {

  [ACTION.REQUEST_METADATA]: (state: CodetableMetadataState, action: RequestMetadata): CodetableMetadataState => {

    return {
      ...state,
      fetching: action.id
    };
  },

  [ACTION.RECEIVE_METADATA]: (state: CodetableMetadataState, action: ReceiveMetadata): CodetableMetadataState => {

    return action.id === state.fetching
      ? {
        ...state,
        fetching: undefined,
        data: action.metadata
      }
      : state;
  },

  [ACTION.FAIL_METADATA]: (state: CodetableMetadataState, action: FailMetadata): CodetableMetadataState => {

    return action.id === state.fetching
      ? {
        ...state,
        fetching: undefined
      }
      : state;
  }
};

const accessReducers: { [indexer: string]: Reducer<CodetableAccessState> } = {

  [ACTION.REQUEST_ACCESS_CODETABLES]: (state: CodetableAccessState, action: RequestAccessCodetables): CodetableAccessState => {

    return {
      ...state,
      fetchingCodetables: action.id
    };
  },

  [ACTION.RECEIVE_ACCESS_CODETABLES]: (state: CodetableAccessState, action: ReceiveAccessCodetables): CodetableAccessState => {

    return action.id === state.fetchingCodetables
      ? {
        ...state,
        fetchingCodetables: undefined,
        data: {
          ...state.data,
          codetables: action.accessCodetables
        }
      }
      : state;
  },

  [ACTION.FAIL_ACCESS_CODETABLES]: (state: CodetableAccessState, action: FailAccessCodetables): CodetableAccessState => {

    return action.id === state.fetchingCodetables
      ? {
        ...state,
        fetchingCodetables: undefined
      }
      : state;
  },

  [ACTION.CLEAR_CODES_ACCESS]: (state: CodetableAccessState, action: ClearCodesAccess): CodetableAccessState => {

    return {
      ...state,
      data: {
        ...state.data,
        codes: undefined
      }
    };
  },

  [ACTION.CLEAR_CODETABLES_ACCESS]: (state: CodetableAccessState, action: ClearCodetablesAccess): CodetableAccessState => {

    return {
      ...state,
      data: {
        ...state.data,
        codetables: undefined
      }
    };
  },

  [ACTION.REQUEST_CODE_ITEM_ACCESS_CODES]: (state: CodetableAccessState, action: RequestCodeItemAccessCodes): CodetableAccessState => {

    return {
      ...state,
      fetchingCodes: action.codeId
    };
  },

  [ACTION.RECEIVE_CODE_ITEM_ACCESS_CODES]: (state: CodetableAccessState, action: ReceiveCodeItemAccessCodes): CodetableAccessState => {
    return action.accessCodes && action.accessCodes.id === state.fetchingCodes
      ? {
        ...state,
        fetchingCodes: undefined,
        data: {
          ...state.data,
          codes: action.accessCodes
        }
      }
      : state;
  },

  [ACTION.FAIL_CODE_ITEM_ACCESS_CODES]: (state: CodetableAccessState, action: FailCodeItemAccessCodes): CodetableAccessState => {
    return {
      ...state,
      fetchingCodes: undefined
    };
  }
};

const metadataReducer: Reducer<CodetableMetadataState> = (
  state: CodetableMetadataState = INITIAL_CODETABLE_METADATA_STATE, action: any) => {
  const r = metadataReducers[action.type];
  return (r && r(state, action)) || state;
};

const accessReducer: Reducer<CodetableAccessState> = (
  state: CodetableAccessState = INITIAL_CODETABLE_ACCESS_STATE, action: any) => {
  const r = accessReducers[action.type];
  return (r && r(state, action)) || state;
};

export const reducer = withOptionsReducer(
  STATE.indicatorFactors,
  mergeReducers({
    metadata: metadataReducer,
    access: accessReducer,
    list: listReducer,
    item: itemReducer
  })
);
